export const initState = {
  client_locations: [],
  isLoaded: false,
  isEmpty: false,
}
